import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { PrimaryButton, SecondaryButton } from 'components/Button';
import { Info, Title } from 'components/Text';
import { BLACK } from 'constants/colors';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import Divider from '@material-ui/core/Divider';
import DialogActions from '@material-ui/core/DialogActions';
import useStyles from './FinancialSecurityDialogStyles';
import DialogContent from '@material-ui/core/DialogContent';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
export default function FinancialSecurityDialog({
  open,
  onPrimaryBtnClick,
  isLoading,
  primaryBtnClickIsDisabled,
  onClose,
  onDone,
  onSecondaryBtnClick,
  secondaryBtnClickIsDisabled,
  deposit
}) {
  const {
    dialogTitleStyle,
    closeIcon,
    submitButton,
    infoBox,
    infoBoxHeader,
    infoBoxIcon,
    infoBoxTitle,
    infoBoxParagraph
  } = useStyles();
  const {
    t
  } = useTranslation();
  const [accepted, setAccepted] = useState(false);
  const {
    customer,
    isBusinessCustomer
  } = useCurrentCustomer();
  const handlePrimaryBtnClick = async () => {
    if (accepted) {
      onDone();
      return;
    }
    if (await onPrimaryBtnClick()) {
      setAccepted(true);
    }
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    "aria-labelledby": "dialog-component",
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "dialog-component"
  }, /*#__PURE__*/React.createElement("div", {
    className: dialogTitleStyle
  }, /*#__PURE__*/React.createElement(Title, {
    component: "h1"
  }, t('register_vehicle.credit_check.financial_security_title')), /*#__PURE__*/React.createElement(SecondaryButton, {
    className: closeIcon,
    outlined: false,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    htmlColor: BLACK
  })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogContent, null, !accepted ? /*#__PURE__*/React.createElement(React.Fragment, null, isBusinessCustomer ?
  /*#__PURE__*/
  // If company customer
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Info, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "register_vehicle.credit_check.requesting_financial_security_company",
    values: {
      companyName: customer?.organizationName,
      financialSecurityAmount: deposit?.amount,
      currency: deposit?.currency
    },
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    }
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Info, null, t('register_vehicle.credit_check.accept_info_financial_security_company')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Info, null, t('register_vehicle.credit_check.deposit_not_paid_financial_security'))) :
  /*#__PURE__*/
  // If private customer
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Info, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "register_vehicle.credit_check.requesting_financial_security_private",
    values: {
      companyName: customer?.personFirstName + ' ' + customer?.personLastName,
      financialSecurityAmount: deposit?.amount,
      currency: deposit?.currency
    },
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    }
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Info, null, t('register_vehicle.credit_check.accept_info_financial_security_private')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Info, null, t('register_vehicle.credit_check.deposit_not_paid_financial_security'))), /*#__PURE__*/React.createElement("div", {
    className: infoBox
  }, /*#__PURE__*/React.createElement("div", {
    className: infoBoxHeader
  }, /*#__PURE__*/React.createElement(InfoOutlined, {
    className: infoBoxIcon
  }), /*#__PURE__*/React.createElement(Title, {
    component: "h2",
    className: infoBoxTitle,
    hasNoSpacing: true
  }, t('register_vehicle.credit_check.about_deposit_title'))), /*#__PURE__*/React.createElement(Info, {
    className: infoBoxParagraph
  }, t('register_vehicle.credit_check.about_deposit_regulation')), /*#__PURE__*/React.createElement(Info, {
    className: infoBoxParagraph
  }, t('register_vehicle.credit_check.about_deposit_settlement')))) : /*#__PURE__*/React.createElement(Info, null, t('register_vehicle.credit_check.invoice_coming_financial_security'))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: submitButton
  }, !accepted && /*#__PURE__*/React.createElement(SecondaryButton, {
    onClick: onSecondaryBtnClick,
    disabled: secondaryBtnClickIsDisabled
  }, t('buttons.cancel')), /*#__PURE__*/React.createElement(PrimaryButton, {
    onClick: handlePrimaryBtnClick,
    loading: isLoading,
    disabled: primaryBtnClickIsDisabled
  }, !accepted ? t('register_vehicle.credit_check.accept') : t('buttons.close'))))));
}